<template>
  <div class="flex flex-col center-content mb-7">
    <h2 class="font-bold text-center mb-5 text-3xl">Deposits</h2>
    <button @click="isOpen = !isOpen" type="button" class="mx-auto inline-flex items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
      Create New Deposit
    </button>
<!--    <transition-->
<!--        enter-active-class="transition ease-out duration-100 transform"-->
<!--        enter-class="opacity-0"-->
<!--        enter-to-class="opacity-100"-->
<!--        leave-active-class="transition ease-in duration-200 transform"-->
<!--        leave-class="opacity-100"-->
<!--        leave-to-class="opacity-0"-->
<!--    >-->
      <transition
          enter-class="transition ease-out duration-100 transform"
          enter-active-class="opacity-0"
          enter-to-class="opacity-100"
          leave-class="transition ease-in duration-200 transform"
          leave-active-class="opacity-100"
          leave-to-class="opacity-0"
      >
      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Create New Deposit
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>
              <div class="my-3">
                <div>
                  <label for="deposit_name" class="block text-sm font-medium text-gray-700">Name</label>
                  <div class="mt-1">
                    <input type="text" v-model="deposit_name" id="deposit_name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300" placeholder="Name of Deposit">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button @click="createDeposit" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-pink-200 sm:ml-3 sm:w-auto sm:text-sm">
              Create
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-gray-200 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>
        </div>
      </div>
      </div>

    </transition>
  </div>
</template>

<script>

  export default {
    name: 'CreateDepositButton',

    data() {
      return {
        isOpen: false,
        deposit_name: null,
      }
    },
    methods: {
      setOpenToFalse() {
        this.isOpen = false;
      },
      createDeposit() {
        let token = document.head.querySelector('meta[name="csrf-token"]');
        axios.post('/admin/store-deposit', {name: this.deposit_name, _token: token.content})
            .then(response => {
              this.$notify({
                text: 'Deposit has been created',
                type: 'success',
              })

              window.location.href = '/admin/deposits/'+response.data.id
            })
      },
    },

  }
</script>

<style scoped>

</style>
